import {isValidEmail} from "../helpers/isValidEmail";

export const newsletterForm = (function ($) {

    function init() {

        const $form = $("#newsletter-form");
        const $btn = $form.find("button.btn");
        const $privacyField = $form.find("#newsletter-form-privacy-acceptance");
        const $emailField = $form.find("#newsletter-form-email");

        $btn.on("click", function () {

            $form.find("span.err").remove();

            let err = false;
            if($emailField.val() === '' || !isValidEmail($emailField.val())) {
                err = true;
                $emailField.parent().append('<span class="err"><strong>Please provide a valid e-mail address</strong></span>')
            }
            if(!$privacyField.is(":checked")) {
                err = true;
                $form.append('<span class="err"><strong>Please authorize the processing of your personal data</strong></span>')
            }
            if(err === false) {
                $form.submit();
                $form.find("span.err").remove();
            }
        });
    }

    return {
        init: init
    }

})(jQuery);
